import { cn } from "cn";
import type * as React from "react";

// A labelled form field (v3.2 forms: Settings, referral editor, Macros): the
// label over the control and an optional hint under it. The control is the
// child (Input, Textarea, Select, or one wrapped with a dictation mic), so
// `htmlFor` must match its id.

export const fieldLabelClassName =
  "block font-v3 text-[13px] font-semibold leading-[18px] text-v3-text-2";

export function FieldLabel({
  className,
  ...props
}: React.ComponentPropsWithRef<"label">): React.JSX.Element {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: the caller passes htmlFor.
    <label
      className={cn(fieldLabelClassName, className)}
      data-slot="field-label"
      {...props}
    />
  );
}

export function Field({
  label,
  htmlFor,
  hint,
  children,
  className,
}: {
  label: React.ReactNode;
  /** The id of the control inside. */
  htmlFor: string;
  /** A short line under the control. */
  hint?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}): React.JSX.Element {
  return (
    <div
      className={cn("min-w-0 space-y-1.5 font-v3", className)}
      data-slot="field"
    >
      <FieldLabel htmlFor={htmlFor}>{label}</FieldLabel>
      {children}
      {hint && (
        <p className="text-[12.5px] leading-[17px] text-v3-text-3">{hint}</p>
      )}
    </div>
  );
}
